import CircularProgress from '@mui/material/CircularProgress';

import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import PrimaryButton, { PrimaryButtonProps } from '../PrimaryButton/PrimaryButton';
import styles from './LoadingButton.module.scss';

type LoadingButtonProps = Omit<PrimaryButtonProps, 'children' | 'style' | 'disabled'> & {
    children: React.ReactNode;
    isLoading: boolean;
    fulfilled?: boolean;
    disabled?: boolean | undefined;
    style?: React.CSSProperties;
};

const LoadingButton = ({
    children,
    isLoading,
    fulfilled = false,
    disabled,
    style = {},
    ...rest
}: LoadingButtonProps) => {
    return (
        <PrimaryButton
            style={{
                position: 'relative',
                paddingRight: isLoading ? '36px' : '',
                ...style,
            }}
            {...rest}
            disabled={isLoading || disabled}
        >
            <>
                {children}
                {isLoading && !fulfilled && (
                    <div className={styles.icon}>
                        <CircularProgress size={20} color="primary" />
                    </div>
                )}
                {!isLoading && fulfilled && (
                    <div className={styles.icon}>
                        <div className={styles.success}>
                            <CheckIcon fill="#FFF" />
                        </div>
                    </div>
                )}
            </>
        </PrimaryButton>
    );
};

export default LoadingButton;
